var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaintHelena(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M22.32 18.56c-4.61-1.8-4.43-5.98-4.25-10.4l.01-.25.21-.14c.38-.26 2.2-.77 4.21-.77s3.83.5 4.21.77l.2.14.02.25c.18 4.42.36 8.6-4.25 10.4l-.18.07z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M26.43 8.18c-.28-.19-1.99-.68-3.93-.68s-3.65.5-3.93.68c-.19 4.48-.28 8.27 3.93 9.91 4.2-1.64 4.12-5.43 3.93-9.91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8fc5ff",
    d: "M18.51 11.04c.05 3.2.71 5.78 3.99 7.05 3.27-1.27 3.94-3.86 3.99-7.05z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#366cc9",
    d: "M22.5 18.1a5.6 5.6 0 0 0 3.3-3.02h-6.6a5.6 5.6 0 0 0 3.3 3.01"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d860",
    d: "M22.46 15.84a.18.18 0 0 0 0 .35h2.68q.13-.17.24-.35zm-.32.9q.02.17.18.18h2.14q.2-.17.36-.35h-2.5a.2.2 0 0 0-.18.17m-.46.74q.02.16.18.17h1.57q.3-.16.56-.35h-2.13a.2.2 0 0 0-.18.18"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d3100",
    d: "M19.4 12.93c.17-.45.55-1.09.7-1.1.14-.03 1.74 3.1 1.62 3.26-.13.14-1.92.24-2.27.17s-.04-2.33-.04-2.33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf6200",
    d: "M21.28 15.6c-.12-.4-2.1-4.08-2.23-4.08-.09 0-.32.34-.5.64a7.5 7.5 0 0 0 1.24 3.95c.67-.05 1.58-.22 1.5-.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M21.95 11.3h.13v3.8h-.13zm1.33-.1h.13v3.9h-.13zm1.23.1h.13v3.8h-.13z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.16 14.14c.2.05 1.04.52 1.56.68.62.19 1.55.16 1.8.16s.73-.73.93-.73h1.26c.19 0 .12 1.25-.36 1.25h-3.38c-.31 0-1.37-.98-1.58-1.08s-.41-.33-.23-.28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M22.5 11.72a.2.2 0 0 1-.2.2h-.7a.2.2 0 1 1 0-.4h.7q.18.02.2.2m1.33-.2a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7a.2.2 0 0 1 .2.2m1.36.4a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7q.18.01.2.2m0 1.09a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7q.18.02.2.2m0 .73a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7q.18.02.2.2m-1.36-1.5a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7c.1 0 .2.1.2.2m0 .77a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7c.1 0 .2.09.2.2m0 .73a.2.2 0 0 1-.2.2h-.7a.2.2 0 0 1 0-.4h.7c.1 0 .2.09.2.2m-1.33-1.3a.2.2 0 0 1-.2.2h-.7a.2.2 0 1 1 0-.4h.7c.11 0 .2.1.2.2m0 .77a.2.2 0 0 1-.2.2h-.7a.2.2 0 1 1 0-.4h.7q.18.02.2.2m0 .72a.2.2 0 0 1-.2.2h-.7a.2.2 0 1 1 0-.4h.7a.2.2 0 0 1 .2.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ac5f1a",
    d: "M20.71 8.27c.03-.16.45-.03.62-.17s.61-.5.98-.05c.2.26.15.43.38.64s1.45.74 1.85.62c-.02.25-.38.37-.38.37s.34.25.38.54-.5-.45-1.28-.25c-.3.09-.65.4-1.27.25-.63-.15-.65-1.1-.66-1.49 0-.14-.63-.35-.62-.46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M21.03 8.19c.03-.13.36 0 .5-.1s.54-.37.81.03c.15.22.1.36.27.55.17.18 1.13.7 1.46.62-.03.2-.33.28-.33.28s.25.22.27.47c.01.24-.38-.4-1.02-.3-.26.05-.56.29-1.06.12s-.45-.93-.43-1.26c0-.11-.5-.32-.47-.41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.22 10.7a.1.1 0 0 1-.07.07.1.1 0 0 1-.08-.07v-.47q.01-.07.08-.08.06.01.07.08zm.56 0a.1.1 0 0 1-.08.07.1.1 0 0 1-.07-.07v-.47q0-.07.07-.08.07.01.08.08zm-.66-2.4a.14.14 0 1 1-.28 0 .14.14 0 0 1 .28 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaintHelena);
export default __webpack_public_path__ + "static/media/saint-helena.92d1da6f8d757299352698f400f7e386.svg";
export { ForwardRef as ReactComponent };